window.Gifty = { key: 'NaPEMdO4RroxX', trigger: false };
(function (e, t) {
	var n = e.createElement(t);
	n.async = true;
	n.src = 'https://static.gifty.nl/js/widget.js';
	var r = e.getElementsByTagName(t)[0];
	r.parentNode.insertBefore(n, r);
})(document, 'script');

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("a.btn").forEach(function (btn) {
    const label = btn.querySelector("span");

    if (label && label.textContent.trim() === "Cadeaubon kopen") {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        if (window.Gifty && typeof window.Gifty.open === "function") {
          window.Gifty.open();
        } else {
          window.open(
            "https://cadeaubon.gifty.nl/de-pindakaaswinkel",
            "_blank"
          );
        }
      });
    }
  });
});
